// Mirrors the funnel stage categories in client/src/components/audience-builder/ai-audience/constants.js
// Duplicated (not imported) to avoid coupling this feature to that in-progress module.
export const funnelStagePresets = [
  { value: 'reached_chatbot', label: 'Reached chatbot' },
  { value: 'completed_onboarding', label: 'Completed onboarding' },
  { value: 'answer_intent', label: 'Answer intent' },
  { value: 'engage_with_content', label: 'Engage with content' },
  { value: 'referral', label: 'Referral' },
  { value: 'readiness', label: 'Readiness' },
  { value: 'redemption', label: 'Redemption' }
]

export const defaultFunnelStageMapping = () => funnelStagePresets.map(preset => ({
  key: preset.value,
  label: preset.label,
  isCustom: false,
  conversationStages: [],
  // Real answer options for this stage's mapped conversation(s), auto-fetched (not manually typed)
  // whenever a conversation+stage pair is added below — see FunnelStageMapping.vue.
  options: []
}))



// WEBPACK FOOTER //
// ./src/components/user-journey/funnelStageConstants.js